<template>
  <section class="case-studies">
    <div class="container">
      <h2 v-scroll-reveal>{{ $t('caseStudies.title') }}</h2>
      <div class="studies">
        <article v-for="study in $tm('caseStudies.items')" :key="study.title" class="study-card">
          <h3>{{ study.title }}</h3>
          <div class="metric">
            <strong>{{ $t('caseStudies.kpi') }}:</strong> {{ study.metric }}
          </div>
          <div class="stack">
            <strong>{{ $t('caseStudies.stack') }}:</strong> {{ study.stack }}
          </div>
          <div class="compliance">
            <span class="badge">{{ study.compliance }}</span>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<style scoped>
.case-studies {
  padding: 80px 20px;
  background-color: var(--primary-light);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

h2 {
  text-align: center;
  margin-bottom: 50px;
  font-size: 2.5rem;
  color: var(--text-color);
}

.studies {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
}

.study-card {
  padding: 40px;
  background-color: var(--white);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  border-left: 5px solid var(--primary-color);
  transition: transform 0.3s ease;
}

.study-card:hover {
  transform: translateY(-5px);
}

h3 {
  margin-bottom: 25px;
  color: var(--text-color);
}

.metric, .stack {
  margin-bottom: 15px;
  line-height: 1.5;
  color: var(--text-color);
}

.compliance {
  margin-top: 25px;
  display: flex;
  gap: 10px;
}

.badge {
  background-color: var(--accent-light);
  color: var(--accent-dark);
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
}

@media (max-width: 600px) {
  .studies {
    grid-template-columns: 1fr;
  }
}
</style>
